import React from 'react'
import { CSVLink } from 'react-csv'
import { snakeCase } from 'lodash'
import FamilyAttributeInterface from '../../../interfaces/FamilyAttribute'
import MemberAttributeInterface from '../../../interfaces/MemberAttribute'

type Props = {
  censusName: string,
  familiesAttributes: Array<FamilyAttributeInterface>
}

const CensusExport: React.FC<Props> = ({ censusName, familiesAttributes }) => {
  const data = () => {
    const rows = [['Census Family Name', 'Type', 'Age', 'Tobacco', 'Gender']]

    familiesAttributes.forEach((familyAttribute: FamilyAttributeInterface) => {
      familyAttribute.members_attributes.forEach((memberAttribute: MemberAttributeInterface) => {
        rows.push(row(familyAttribute.name, memberAttribute))
      })
    })

    return rows
  }

  const row = (name: string, memberAttribute: MemberAttributeInterface) => {
    return [
      name,
      memberAttribute.member_type,
      memberAttribute.age,
      memberAttribute.tobacco ? 'Yes' : 'No',
      memberAttribute.gender
    ]
  }

  return (
    <CSVLink
      className="census-export pure-button pure-input-1 pure-button-secondary small inline-right"
      data={data()}
      filename={snakeCase(censusName)}
      enclosingCharacter=""
    >
      Export Census
    </CSVLink>
  )
}

export default CensusExport
